import { Injector } from '@angular/core';

/**
 * Injector global, para el código que necesita un servicio fuera de un contexto de DI (helpers
 * estáticos, modelos, decoradores). Lo setea `AppModule` en su constructor.
 *
 * Vive en su propio archivo a propósito: estaba declarado dentro de `app.module.ts`, así que
 * cualquier helper que lo importara arrastraba el grafo completo de la app (LayoutModule, fuse,
 * OIDC, ngx-permissions...). En runtime eso pasa desapercibido, pero en un spec de lógica pura
 * hace fallar el TestBed con "X does not have a module def (ɵmod property)" y multiplica el
 * tiempo de arranque de la suite.
 *
 * Por eso `app.module` tampoco lo re-exporta: si alguien vuelve a escribir
 * `import { AppInjector } from 'app/app.module'`, queremos que rompa al compilar y no que funcione
 * en silencio arrastrando la app entera. `main.ts` es el único que debería importar `app.module`.
 * Lo verifica [module-eval-cycles.spec.ts](../testing/module-eval-cycles.spec.ts).
 */
export let AppInjector: Injector;

export const setAppInjector = (injector: Injector): void => {
  AppInjector = injector;
};
